export async function enviardatosservidor(collection, url) {
  const querys = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(collection),
  });
  const retorno = await querys.json();
  return retorno;
}
